// extracted by mini-css-extract-plugin
module.exports = {"container":"_2vM7_cl5fn6u3eRuC31aek","action":"_1WgPOTn3kFEnVYjBl3QysS","title":"x98qQZJw2u2QCMx6cSU1o","desc":"_1DSJ7ywprHnjsuTgxvCZBV"};